import { MarketTypes } from "app/utils/const";
import { connect } from "react-redux";
import "./AsianEventScreenMarketsHeader.scss";
import AsianEventScreen1x2Header from "./components/AsianEventScreen1x2Header";
import AsianEventScreenCorrectScoreHeader from "./components/AsianEventScreenCorrectScoreHeader";
import AsianEventScreenFirstLastGoalHeader from "./components/AsianEventScreenFirstLastGoalHeader";
import AsianEventScreenHDPHeader from "./components/AsianEventScreenHDPHeader";
import AsianEventScreenOutrightHeader from "./components/AsianEventScreenOutrightHeader";
import AsianEventScreenTotalOddEvenHeader from "./components/AsianEventScreenTotalOddEvenHeader";

const AsianEventScreenMarketsHeader = (props: {
  selectedMarketType: string;
  favouritesOnly: boolean;
  bookmarksOnly: boolean;
}): React.JSX.Element => {
  const { selectedMarketType, favouritesOnly, bookmarksOnly } = props;
  if (favouritesOnly || bookmarksOnly) {
    return <AsianEventScreenHDPHeader />;
  } else {
    switch (selectedMarketType) {
      case MarketTypes.HANDICAP:
        return <AsianEventScreenHDPHeader />;

      case MarketTypes.ONE_X_TWO:
        return <AsianEventScreen1x2Header />;

      case MarketTypes.FIRST_LAST_GOAL:
        return <AsianEventScreenFirstLastGoalHeader />;

      case MarketTypes.TOTAL_ODD_EVEN:
        return <AsianEventScreenTotalOddEvenHeader />;

      case MarketTypes.CORRECT_SCORE:
        return <AsianEventScreenCorrectScoreHeader />;

      case MarketTypes.OUTRIGHT:
        return <AsianEventScreenOutrightHeader />;

      default:
        return <AsianEventScreenHDPHeader />;
    }
  }
};

const mapStateToProps = state => ({
  selectedMarketType: state.sportsSelectionListModel.selectedMarketType,
  favouritesOnly: state.competitionListModel.favouritesOnly,
  bookmarksOnly: state.asianCompetitionListFiltersModel.bookmarksOnly,
});

export default connect(mapStateToProps)(AsianEventScreenMarketsHeader) as any;
